module.exports = __webpack_public_path__ + "img/copy.9855a89d.svg";